/**
 * Default db infos
 */
export default {
  sqlite: {
    connection: {
      filename: '.tmp/data.db',
    },
    useNullAsDefault: true,
  },
  postgres: {},
  mysql: {},
};
